module.exports = __webpack_public_path__ + "media/images/icons/flags/BR-6628cc0592ee2d2f4a45a2b33d1142f6.svg";